/** Formatação só de apresentação. Dinheiro chega em centavos inteiros da API. */

export function reais(centavos: number): string {
  const negativo = centavos < 0
  const abs = Math.abs(centavos)
  const inteira = Math.floor(abs / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
  return `${negativo ? '−' : ''}R$ ${inteira},${String(abs % 100).padStart(2, '0')}`
}

export function reaisCompacto(centavos: number): string {
  const v = centavos / 100
  if (Math.abs(v) >= 1e6) return `R$ ${(v / 1e6).toFixed(1).replace('.', ',')} mi`
  if (Math.abs(v) >= 1e3) return `R$ ${(v / 1e3).toFixed(0)} mil`
  return reais(centavos)
}

const MESES = ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez']
export function mesCurto(competencia: string): string {
  const [a, m] = competencia.split('-')
  return `${MESES[Number(m) - 1]}/${a!.slice(2)}`
}

export function dataBr(iso: string | Date | null | undefined): string {
  if (!iso) return '—'
  const s = typeof iso === 'string' ? iso : iso.toISOString()
  const [a, m, d] = s.slice(0, 10).split('-')
  return `${d}/${m}/${a}`
}

export const ROTULO_MODELO: Record<string, string> = {
  '55': 'NF-e',
  '65': 'NFC-e',
  '57': 'CT-e',
  '67': 'CT-e OS',
  '62': 'NFCom',
  '66': 'NF3e',
  NFSE_NAC: 'NFS-e Nac.',
  NFSE_ABRASF: 'NFS-e mun.',
}

export const ROTULO_SITUACAO: Record<string, string> = {
  AUTORIZADO: 'Autorizada',
  CANCELADO: 'Cancelada',
  DENEGADO: 'Denegada',
  SEM_PROTOCOLO: 'Sem protocolo',
}

export const ROTULO_PAPEL: Record<string, string> = { ENTRADA: 'Entrada', SAIDA: 'Saída', INTERNO: 'Entre unidades' }
